import { useEffect, useState } from "react";
import axios from "axios";
import { formatTimestamp } from "../utils/timestampUtils";

export const useS3ObjectLastModified = (
  url?: string | null
): { lastModified: string; loading: boolean } => {
  const [lastModified, setLastModified] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!url) {
      setLastModified("");

      setLoading(false);

      return;
    }

    setLoading(true);

    axios
      .get(url, { responseType: "blob" })
      .then(response => {
        const lm = response.headers["last-modified"];

        if (lm) {
          setLastModified(formatTimestamp(lm));
        } else {
          setLastModified("");
        }
      })
      .catch(() => {
        setLastModified("");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [url]);

  return { lastModified, loading };
};
